import { useState } from 'react';
import { useEmailVerificationGrace } from './useEmailVerificationGrace';

/**
 * 기능 차단 관리 훅
 * @param {Object} user - Firebase 사용자 객체
 * @returns {object} - 기능 차단 관련 상태와 함수들
 */
export const useFeatureBlock = (user) => {
  const [blockModalOpen, setBlockModalOpen] = useState(false);
  const { isGraceExpired } = useEmailVerificationGrace(user);

  /**
   * 기능 실행 전 차단 체크
   * @param {Function} callback - 실행할 기능 함수
   * @returns {boolean} - 기능 실행 여부
   */
  const checkAndExecute = (callback) => {
    // 유예 기간이 만료된 이메일 사용자는 차단
    if (isGraceExpired) {
      setBlockModalOpen(true);
      return false;
    }
    
    // 정상 사용자는 기능 실행
    if (callback && typeof callback === 'function') {
      callback();
    }
    return true;
  };

  /**
   * 모달 닫기
   */
  const closeBlockModal = () => {
    setBlockModalOpen(false);
  };

  /**
   * 외부에서 모달 열기 (직접 URL 접근 차단용)
   */
  const openBlockModal = () => {
    if (isGraceExpired) {
      setBlockModalOpen(true);
    }
  };

  return {
    blockModalOpen,
    isGraceExpired,
    checkAndExecute,
    closeBlockModal,
    openBlockModal
  };
}; 